export default "static/src/images/limes_accedi_bg.jpg";